import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from 'context/UserContext';
import { setToken, decodeToken } from 'data/users';
import Loading from 'components/Loading';

const SSOCallback = () => {
    const history = useHistory();
    const location = useLocation();
    const { setUserInfo } = useContext(UserContext);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const access = params.get('access');
        const refresh = params.get('refresh');
        const ssoError = params.get('sso_error');

        if (ssoError) {
            history.push(`/?sso_error=${ssoError}`);
            return;
        }

        if (!access || !refresh) {
            history.push('/');
            return;
        }

        setToken({ access, refresh });
        const decode = decodeToken();
        setUserInfo({ token: access, isAdmin: decode.superuser });
        history.push('/admin/dashboard');
    }, []);

    return <Loading />;
};

export default SSOCallback;
